<template>
  <div>
    <v-container
      class="my-4 my-md-16 px-6 px-sm-16 px-md-4"
      style="max-width: 1000px"
    >
      <ValidationObserver ref="observer" v-on:keyup.enter="signIn">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5" lg="5" align="center">
            <img
              :src="
                $vuetify.theme.dark
                  ? require('@/app/core-module/assets/images/LOGO_DARK_MODE.png')
                  : require('@/app/core-module/assets/images/LOGO.png')
              "
              alt="Logo"
              class="mb-10"
              height="auto"
              width="180"
            />

            <v-card elevation="0" class="border-lg">
              <div v-if="$route.query.token" class="pa-10 text-center">
                <v-progress-circular indeterminate color="primary" size="64" class="mb-4"></v-progress-circular>
                <h3>Authenticating with ZeroSuite...</h3>
                <div v-if="error" class="error--text mt-4">{{ error }}</div>
              </div>
              <div v-else class="pa-4 pa-md-10">
                <div
                  class="
                    text-subtitle-2
                    textLight--text
                    mt-6
                    mb-2
                    text-start
                    font-weight-thin
                  "
                >
                  <div style="font-weight: 800; color: #281166; font-size: 1.2rem; margin-bottom: 8px;">EMPLOYEE PORTAL</div>
                  {{ $t("user.signIn.welcome") }}
                </div>

                <div
                  class="
                    text-h5
                    textLight--text
                    mt-3
                    mb-7
                    text-start
                    font-weight-medium
                  "
                >
                  {{ $t("user.signIn.signInto") }}
                </div>

                <validation-provider v-slot="{ errors }" rules="required">
                  <div
                    class="
                      text-start
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                      mb-0
                    "
                  >
                    {{ $t("user.signIn.yourEmail") }}
                  </div>

                  <v-text-field
                    hide-details
                    :error="emailErr"
                    v-model="emailOrCivilIdOrPassport"
                    @click="
                      () => {
                        emailErr = pwdErr = false;
                        error = null;
                      }
                    "
                    :error-messages="errors"
                    outlined
                    :append-icon="emailErr ? 'mdi-alert-circle-outline' : null"
                    dense
                    class="rounded-md text-body-2"
                  >
                  </v-text-field>

                  <div
                    v-if="emailErr"
                    class="error--text text-start text-caption font-weight-thin"
                  >
                    {{ $t("user.signIn.emailErrorMsg") }}
                  </div>
                </validation-provider>

                <validation-provider v-slot="{ errors }" rules="required">
                  <div
                    class="
                      text-start
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                      mt-3
                      mb-1
                    "
                  >
                    {{ $t("user.password") }}
                  </div>

                  <v-text-field
                    hide-details
                    :error="pwdErr"
                    v-model="password"
                    @click="
                      () => {
                        emailErr = pwdErr = false;
                        error = null;
                      }
                    "
                    :error-messages="errors"
                    outlined
                    dense
                    class="rounded-md text-body-2"
                    :append-icon="
                      pwdErr
                        ? 'mdi-alert-circle-outline'
                        : passwordValue
                        ? 'mdi-eye-off'
                        : 'mdi-eye'
                    "
                    @click:append="() => (passwordValue = !passwordValue)"
                    :type="passwordValue ? 'password' : 'text'"
                    :password_value="password"
                  >
                  </v-text-field>

                  <div
                    v-if="pwdErr"
                    class="error--text text-start text-caption font-weight-thin"
                  >
                    {{ $t("user.signIn.passwordErrorMsg") }}
                  </div>
                </validation-provider>
                <div
                  v-if="error"
                  class="
                    error--text
                    text-center text-caption
                    font-weight-medium
                    mt-4
                  "
                >
                  {{ error }}
                </div>
                <v-btn
                  @click="signIn"
                  :loading="loading"
                  depressed
                  large
                  dark
                  class="text-subtitle-1 rounded-md mb-2 mt-5"
                  color="textLight"
                  style="width: 100%"
                >
                  {{ $t("user.signIn.login").toUpperCase() }}
                </v-btn>

                <router-link
                  style="text-decoration: none"
                  :to="{ name: 'ForgotPassword' }"
                >
                  <div class="primary--text text-caption font-weight-thin">
                    {{ $t("user.forgotPassword") }}
                  </div>
                </router-link>
              </div>
            </v-card>

            <!--            <div class="my-5 text-caption font-weight-thin">-->
            <!--              {{ $t("user.signUp.dontHaveAccount") }}-->

            <!--              <span>-->
            <!--                <router-link-->
            <!--                  style="text-decoration: none"-->
            <!--                  :to="{ name: 'SignUp' }"-->
            <!--                >-->
            <!--                  {{ $t("user.signUp.signUp") }}-->
            <!--                </router-link>-->
            <!--              </span>-->

            <!--              {{ $t("user.here") }}-->
            <!--            </div>-->

            <!--            <div class="d-flex align-center my-5">
              <v-divider style="border-color: #281166" />

              <span class="px-2 textLight&#45;&#45;text text-caption font-weight-thin">
                {{ $t("user.signIn.orContinueWith") }}
              </span>

              <v-divider style="border-color: #281166" />
            </div>

            <div class="d-flex align-center justify-space-around mb-6">
              <v-card flat class="rounded-md">
                <v-icon class="pa-3" size="45" color="#1877F2">
                  mdi-facebook
                </v-icon>
              </v-card>

              <v-card flat class="rounded-md">
                <img
                  class="pa-3"
                  :src="
                    require('@/app/user-module/assets/images/Google__Logo.png')
                  "
                  alt="Google_Logo"
                  height="60"
                  width="60"
                />
              </v-card>

              <v-card flat class="rounded-md">
                <v-icon class="pa-3" size="45" color="#0A66C2">
                  mdi-linkedin
                </v-icon>
              </v-card>
            </div>-->
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import "../../core-module/util/validationRules";
import { signIn } from "../methods/signIn";
import { ssoSignIn } from "../methods/ssoSignIn";

export default {
  data() {
    return {
      loading: false,
      emailOrCivilIdOrPassport: null,
      password: null,
      passwordValue: String,
      error: null,
      emailErr: false,
      pwdErr: false,
    };
  },
  
  async mounted() {
    const token = this.$route.query.token;
    if (token) {
      this.loading = true;
      const response = await ssoSignIn(token);
      if (response && response.data) {
        window.location.href = '/';
      } else {
        this.error = "SSO Login failed: " + JSON.stringify(response.error);
        console.error("SSO Error:", response);
        this.loading = false;
      }
    }
  },
  methods: {
    async signIn() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.loading = true;

        signIn(this.emailOrCivilIdOrPassport, this.password).then(response => {
          if (response.data) location.reload();
          else if (response.error) {
            if (response.error.includes("NOT_FOUND")) {
              this.emailErr = true;
              this.error = null;
            } else if (response.error.includes("UNAUTHORIZED")) {
              this.emailErr = this.pwdErr = false;
              this.error = this.$t("user.signIn.notRegisteredErrorMsg");
            } else if (response.error.includes("WRONG_PASSWORD")) {
              this.pwdErr = true;
              this.error = null;
            } else this.error = this.$t("somethingWentWrong");
          }

          this.loading = false;
        });
      }
    },
  },
};
</script>
